export default {"src":"/polygon/_next/static/media/ethereum-icon.c25bc45c.svg","height":20,"width":20};